import { render, staticRenderFns } from "./PageCaption.vue?vue&type=template&id=256e292a&scoped=true&"
import script from "./PageCaption.vue?vue&type=script&lang=ts&"
export * from "./PageCaption.vue?vue&type=script&lang=ts&"
import style0 from "./PageCaption.vue?vue&type=style&index=0&id=256e292a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256e292a",
  null
  
)

export default component.exports